"use client";

// SFWL-005: dataSource is now an open string carrying the resolved provider
// id from the backend (e.g. "hyperliquid", "cqg_replay", future "cqg"),
// optionally with a "-ws" suffix when live ticks are streaming.
interface ConnectionStatusProps {
  isConnected: boolean;
  latency: number | null;
  dataSource: string | null;
}

function formatDataSource(source: string): { label: string; live: boolean } {
  const live = source.endsWith("-ws");
  const id = live ? source.slice(0, -3) : source;
  const friendly =
    id === "hyperliquid"
      ? "Hyperliquid"
      : id === "cqg"
        ? "CQG"
        : id === "cqg_replay"
          ? "CQG Replay"
          : id;
  return { label: `${friendly} ${live ? "Live" : "REST"}`, live };
}

export function ConnectionStatus({
  isConnected,
  latency,
  dataSource,
}: ConnectionStatusProps) {
  const formatted = dataSource ? formatDataSource(dataSource) : null;

  return (
    <div className="flex items-center gap-3 text-xs">
      {/* Connection indicator */}
      <div className="flex items-center gap-1.5">
        <div
          className={`h-2 w-2 rounded-full ${
            isConnected ? "bg-green-500 animate-pulse" : "bg-red-500"
          }`}
        />
        <span className="text-slate-400">
          {isConnected ? (latency ? `${latency}ms` : "Live") : "Offline"}
        </span>
      </div>

      {/* Data source indicator */}
      {formatted && (
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500">|</span>
          <span
            className={`px-1.5 py-0.5 rounded text-[10px] font-medium uppercase ${
              formatted.live
                ? "bg-green-500/20 text-green-400"
                : "bg-blue-500/20 text-blue-400"
            }`}
          >
            {formatted.label}
          </span>
        </div>
      )}
    </div>
  );
}
